import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';


@Injectable({
  providedIn: 'root'
})
export class ShowToastrService {

  constructor(private toastr: ToastrService) {

  }

  showError(error, secundary?, timeout?) {
    timeout = (timeout) ? timeout : 5000;
    secundary = (secundary) ? secundary : '';

    this.toastr.error(
      error,
      secundary
    );

  }

  showSucces(msj, secundary?, timeout?) {
    timeout = (timeout) ? timeout : 5000;
    secundary = (secundary) ? secundary : '';

    this.toastr.success(
      msj,
      secundary
    );

  }

  showInfo(msj, secundary?, timeout?) {
    timeout = (timeout) ? timeout : 5000;
    secundary = (secundary) ? secundary : '';

    this.toastr.info(
      msj,
      secundary
    );

  }


}
